import { render, staticRenderFns } from "./tyyPractiseTestRecord.vue?vue&type=template&id=79dbe8f5&"
import script from "./tyyPractiseTestRecord.vue?vue&type=script&lang=js&"
export * from "./tyyPractiseTestRecord.vue?vue&type=script&lang=js&"
import style0 from "./tyyPractiseTestRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports